/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ThreediModelTaskNameEnum } from "./ThreediModelTaskNameEnum";
import {
  ThreediModelTaskNameEnumFromJSON,
  ThreediModelTaskNameEnumFromJSONTyped,
  ThreediModelTaskNameEnumToJSON,
  ThreediModelTaskNameEnumToJSONTyped,
} from "./ThreediModelTaskNameEnum";
import type { ThreediModelTaskStatusEnum } from "./ThreediModelTaskStatusEnum";
import {
  ThreediModelTaskStatusEnumFromJSON,
  ThreediModelTaskStatusEnumFromJSONTyped,
  ThreediModelTaskStatusEnumToJSON,
  ThreediModelTaskStatusEnumToJSONTyped,
} from "./ThreediModelTaskStatusEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface ThreediModelTask
 */
export interface ThreediModelTask {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name: ThreediModelTaskNameEnum;
  /**
   *
   */
  params?: any | null;
  /**
   *
   */
  readonly created?: Date;
  /**
   *
   */
  readonly lastUpdated?: Date;
  /**
   *
   */
  status?: ThreediModelTaskStatusEnum;
  /**
   *
   */
  detail?: any | null;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the ThreediModelTask interface.
 */
export function instanceOfThreediModelTask(value: object): value is ThreediModelTask {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function ThreediModelTaskFromJSON(json: any): ThreediModelTask {
  return ThreediModelTaskFromJSONTyped(json, false);
}

export function ThreediModelTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ThreediModelTask {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: ThreediModelTaskNameEnumFromJSON(json["name"]),
    params:
      json["params"] === undefined ? undefined : json["params"] === null ? null : json["params"],
    created: json["created"] == null ? undefined : parseDateTime(json["created"]),
    lastUpdated: json["last_updated"] == null ? undefined : parseDateTime(json["last_updated"]),
    status: json["status"] == null ? undefined : ThreediModelTaskStatusEnumFromJSON(json["status"]),
    detail:
      json["detail"] === undefined ? undefined : json["detail"] === null ? null : json["detail"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function ThreediModelTaskToJSON(json: any): ThreediModelTask {
  return ThreediModelTaskToJSONTyped(json, false);
}

export function ThreediModelTaskToJSONTyped(
  value?: Omit<ThreediModelTask, "url" | "created" | "lastUpdated" | "threedimodel" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: ThreediModelTaskNameEnumToJSON(value["name"]),
    params: value["params"],
    status: ThreediModelTaskStatusEnumToJSON(value["status"]),
    detail: value["detail"],
  };
}
